import { useRef } from "react";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import ScreenShareMenu from "./ScreenShareMenu";
import { WORKSHOP_ICONS } from "./workshop-view";

const WorkshopEmpty = ({ labels, busy, disabled, onMockup, onCode, share }) => {
  const fileRef = useRef(null);

  const pickFile = ({ target }) => {
    const file = target.files && target.files[0];
    target.value = null;
    if (file) onMockup(file);
  };

  return (
    <div className="workshop-empty">
      <div className="workshop-empty__inner">
        <span className="workshop-empty__icon">
          <CanvasIcon
            path={WORKSHOP_ICONS.screen}
            size={28}
            strokeWidth={1.6}
          />
        </span>
        <h2>{labels.TITLE}</h2>
        <p>{labels.TEXT}</p>
        <div className="workshop-empty__options">
          <div className="workshop-empty__option">
            <strong>{labels.MOCKUP_TITLE}</strong>
            <span>{busy ? labels.GENERATING : labels.MOCKUP_TEXT}</span>
            <button
              type="button"
              className="workshop-button workshop-button--primary"
              disabled={disabled}
              onClick={() => fileRef.current && fileRef.current.click()}
            >
              <CanvasIcon
                path={busy ? WORKSHOP_ICONS.busy : WORKSHOP_ICONS.image}
              />
              {labels.MOCKUP_ACTION}
            </button>
          </div>
          <div className="workshop-empty__option">
            <strong>{labels.CODE_TITLE}</strong>
            <span>{labels.CODE_TEXT}</span>
            <button
              type="button"
              className="workshop-button workshop-button--outline"
              disabled={disabled}
              onClick={onCode}
            >
              <CanvasIcon path={WORKSHOP_ICONS.code} strokeWidth={1.9} />
              {labels.CODE_ACTION}
            </button>
          </div>
        </div>
        {share ? (
          <div className="workshop-empty__share">
            <ScreenShareMenu share={share} withLabel />
          </div>
        ) : null}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        className="workshop__file"
        onChange={pickFile}
      />
    </div>
  );
};

WorkshopEmpty.propTypes = {
  labels: PropTypes.object.isRequired,
  busy: PropTypes.bool,
  disabled: PropTypes.bool,
  onMockup: PropTypes.func.isRequired,
  onCode: PropTypes.func.isRequired,
  share: PropTypes.object,
};

WorkshopEmpty.defaultProps = {
  busy: false,
  disabled: false,
  share: null,
};

export default WorkshopEmpty;
